import { Text, TextProps } from './Themed';
import appFonts from '@/theme/typography';

export function MonoText(props: TextProps) {
  return <Text {...props} style={[props.style, { fontFamily: appFonts.mono }]} />;
}
